// import { INavData } from '../../dist/@coreui/angular';
import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    title: true,
    name: 'Store Analytics',
  },
  {
    name: 'Footfall',
    url: '/footfalls',
    icon: 'icon-chart',
  },
  {
    name: 'Demographics',
    url: '/demographics',
    icon: 'icon-emotsmile',
  },
  {
    name: 'Shoppers Profiles',
    url: '/shopper-profiles',
    icon: 'icon-people',
  },
  {
    name: 'Heatmap',
    url: '/heatmaps',
    icon: 'icon-size-actual ',
  },

  {
    title: true,
    name: 'Category Insights',
  },
  {
    name: 'Category View',
    url: '/category-view',
    icon: 'icon-equalizer',
  },

  {
    title: true,
    name: 'Covid-19',
  },
  {
    name: 'Social Distancing',
    url: '/sd',
    icon: 'icon-people',
  },
  {
    name: 'Mask Detection',
    url: '/md',
    icon: 'icon-emotsmile',
  },
  {
    name: 'Occupancy',
    url: '/lo',
    icon: 'icon-eye',
  },
  {
    name: 'Sanitation',
    url: '/sanitation',
    icon: 'icon-eye',
  },
  {
    name: 'Members',
    url: '/members',
    icon: 'icon-chart',
  },
];
